export const url = () => {
  if (window.location.href.includes('new')) {
    return 'https://api-colombia.keepsmiling.click'
  }
  if (window.location.href.includes('qa')) {
    return 'https://api-qa.keepsmiling.click'
  }
  return 'https://api.test.keepsmiling.app'
}
